/**
 * TrendChart — cumulative overall-score line chart over time. Reads the
 * `trend` array returned by GET /api/school/stats/student/{id}.
 */
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import type { TrendPoint } from "../api/school";

export function TrendChart({ data, height = 220 }: { data: TrendPoint[]; height?: number }) {
  if (!data.length) {
    return (
      <div className="text-center text-sm text-slate-500 italic py-8">
        暂无趋势数据
      </div>
    );
  }
  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={{ top: 8, right: 16, left: -10, bottom: 8 }}>
        <CartesianGrid stroke="#e2e8f0" strokeDasharray="3 3" />
        <XAxis dataKey="date" tick={{ fill: "#64748b", fontSize: 11 }} />
        <YAxis domain={[0, 100]} tick={{ fill: "#64748b", fontSize: 11 }} />
        <Tooltip
          contentStyle={{ fontSize: 12, borderRadius: 6 }}
          formatter={(v) => [v as number, "综合得分"]}
        />
        <Line
          type="monotone"
          dataKey="score"
          stroke="#0ea5e9"
          strokeWidth={2}
          dot={{ r: 4, fill: "#0ea5e9" }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
